import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import News from "./pages/News";
import Calendar from "./pages/Calendar";
import BoardOfDirectors from "./pages/BoardOfDirectors";
import Coaches from "./pages/Coaches";
import Donate from "./pages/Donate";
import Regattas from "./pages/Regattas";
import Sponsors from "./pages/Sponsors";
import Media from "./pages/Media";
import Volunteers from "./pages/Volunteers";
import AboutUs from "./pages/AboutUs";
import StudentForms from "./pages/StudentForms";
import Archives from "./pages/Archives";
import Shop from "./pages/Shop";


import "./App.css";

function App() {
  return (
    <Router>
      <div className="background-wrapper">
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HeroSection />} />
            <Route path="/news" element={<News />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/gallery" element={<Media />} />
            <Route path="/regattas" element={<Regattas />} />
            <Route path="/student-forms" element={<StudentForms />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/volunteers" element={<Volunteers />} />
            <Route path="/coaches" element={<Coaches />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/board" element={<BoardOfDirectors />} />
            <Route path="/archives" element={<Archives />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;